export const palette = {
  primary: "#C6DFDB",
  whiteShade: "#fff",
  secondary: "#AABFBC",
};
